import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { useHistory } from 'react-router-dom'
import { displayPrice } from 'utils/string'
import Input from 'components/inputs/Input'
import Item from '../core/Item'
import React from 'react'

interface RefundProps {
  selectedData: payments.SelectedData
  response?: payments.Quote
  selectData: React.Dispatch<React.SetStateAction<payments.SelectedData>>
}

const Refund: React.FC<RefundProps> = ({ response, selectedData, selectData }) => {
  const totalToBeRefunded = response?.flags?.hasRefund && response?.refund?.paidGross
    ? Number(response.refund.paidGross)
    : 0

  const { goBack } = useHistory()
  const { t } = useTranslation('warehouse')

  return <>
    <div className='title'>
      <div>{t('returnDetails')}</div>
      <div>{t('completeTheFormalities')}</div>
    </div>

    <div className='resignation__main'>
      <div className='resignation__list --noMargin'>
        <Item
          icon='payments'
          title={t('toBeReturned')}
          desc={displayPrice(totalToBeRefunded)}
        />
        <hr />

        <div className='title'>
          <div>{t('fillInTheMissingDetailsForTheRefund')}</div>
        </div>
        <Input
          name='refundName'
          label={t('recipientName')}
          placeholder={t('enterTheRecipientName')}
          value={selectedData.refundName || ''}
          changeHandler={e => {
            selectData(prev => ({ ...prev, refundName: e.target.value }))
          }}
        />
        <Input
          name='refundAccountNumber'
          label={t('bankAccountNumber')}
          placeholder={t('enterYourBankAccountNumber')}
          value={selectedData.refundAccountNumber || ''}
          changeHandler={e => {
            selectData(prev => ({ ...prev, refundAccountNumber: e.target.value }))
          }}
        />
      </div>

      <div className='resignation__buttons'>
        <ArrowBtn
          enlarged
          disabled={totalToBeRefunded > 0 && (!selectedData.refundName || !selectedData.refundAccountNumber)}
          text={t((totalToBeRefunded > 0 && selectedData.refundName && selectedData.refundAccountNumber)
            ? 'save'
            : 'next')}
          action={goBack}
        />

        <BackBtn />
      </div>
    </div>
  </>
}

export default Refund